import * as lib from 'Root/lib/lib.js'

const SCROLL_HIDE_CLASS = 'header-hidden'
const MOB_SECTION_OPEN_CLASS = 'section-open'
const MOB_MENU_OPEN_CLASS = 'mob-menu-open'

class Header {
    constructor(element) {
        if (!element) return

        this.element = element

        this._iniElements()

        this._iniStickyPosition()

        this._iniMobMenu()
    }

    _iniElements() {
        this.mobMenu = document.querySelector('.header__mob-menu')
        this.mobMenuSectionLinks = document.querySelectorAll('.header__mob-menu__section__head')
        this.mobMenuSubmenuLinks = document.querySelectorAll('.header__mob-menu__global-links a.has-submenu')
    }

    _iniStickyPosition() {
        let lastScrollY = window.pageYOffset

        window.addEventListener('scroll', () => {
            const newScrollY = window.pageYOffset

            newScrollY > lastScrollY
                ? document.body.classList.add(SCROLL_HIDE_CLASS)
                : document.body.classList.remove(SCROLL_HIDE_CLASS)

            lastScrollY = newScrollY
        })

        window.addEventListener('resize', () => {
            document.body.classList.remove(SCROLL_HIDE_CLASS)
        })
    }

    _iniMobMenu() {
        this.element.querySelector('.header__bar__burger a').addEventListener('click', () => {
            if (!this.element.classList.contains(MOB_MENU_OPEN_CLASS)) {
                this.openMobMenu()
            } else {
                this.closeMobMenu()
            }
        })

        this.mobMenuSectionLinks.forEach((el) => {
            el.addEventListener('click', (e) => {
                const section = e.currentTarget.parentNode
                const sectionBody = section.querySelector('.header__mob-menu__section__body')

                if (!section.classList.contains(MOB_SECTION_OPEN_CLASS)) {
                    section.classList.add(MOB_SECTION_OPEN_CLASS)
                    $(sectionBody).slideDown()
                } else {
                    section.classList.remove(MOB_SECTION_OPEN_CLASS)
                    $(sectionBody).slideUp()
                }
            })
        })

        this.mobMenuSubmenuLinks.forEach((el) => {
            el.addEventListener('click', (e) => {
                const section = e.currentTarget.parentNode
                const sectionBody = section.querySelector('.header__mob-menu__global-links__submenu')

                if (!section.classList.contains(MOB_SECTION_OPEN_CLASS)) {
                    section.classList.add(MOB_SECTION_OPEN_CLASS)
                    $(sectionBody).slideDown()
                } else {
                    section.classList.remove(MOB_SECTION_OPEN_CLASS)
                    $(sectionBody).slideUp()
                }
            })
        })

        $(window).on('resize', () => {
            this._setMobMenuHeight()
        })
    }

    openMobMenu() {
        this.element.classList.add(MOB_MENU_OPEN_CLASS)
        lib.disableBodyScroll()

        // For browser bottom bar
        this._setMobMenuHeight()
        setTimeout(() => {
            this._setMobMenuHeight()
        }, 200)
    }

    closeMobMenu() {
        this.element.classList.remove(MOB_MENU_OPEN_CLASS)
        lib.enableBodyScroll()
    }

    _setMobMenuHeight() {
        const headerBarHeight = $('.header__bar').outerHeight()
        this.mobMenu.style.height = `${window.innerHeight - headerBarHeight}px`
    }
}

export default Header
